var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMonitorRecorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44 17.97c-3.98 0-5.19-1.21-5.19-5.19V6.44c0-3.98 1.21-5.19 5.19-5.19H8c.41 0 .75.34.75.75s-.34.75-.75.75H6.44c-3.14 0-3.69.55-3.69 3.69v6.33c0 3.14.55 3.69 3.69 3.69h11.11c3.14 0 3.69-.55 3.69-3.69v-.89c0-.41.34-.75.75-.75s.75.34.75.75v.89c.01 3.99-1.2 5.2-5.18 5.2H6.44z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22v-4.78c0-.41.34-.75.75-.75s.75.34.75.75V22c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM2 13.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9c.41 0 .75.34.75.75s-.34.75-.75.75h-9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 10.12c-1.57 0-2.59-1.02-2.59-2.59V4.01c0-1.52 1.23-2.75 2.75-2.75h4.6a2.59 2.59 0 0 1 2.59 2.59v3.68a2.59 2.59 0 0 1-2.59 2.59H13.1zm-1.09-6.11v3.52c0 .98.62 1.09 1.09 1.09h4.76c.6 0 1.09-.49 1.09-1.09V3.85c0-.6-.49-1.09-1.09-1.09h-4.6c-.69 0-1.25.56-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.48 8.53-1.21-.85a.75.75 0 0 1-.32-.61V4.31c0-.24.12-.47.32-.61l1.21-.85c.52-.37 1.08-.44 1.54-.2.46.24.72.74.72 1.38v3.33c0 .64-.26 1.14-.72 1.38-.17.09-.36.13-.57.13-.32 0-.65-.11-.97-.34zm.77-1.29v-3.1l-.8.56v1.98l.8.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMonitorRecorder);
export default __webpack_public_path__ + "static/media/vuesax-outline-monitor-recorder.2ecdb97d4079e4f2c53ada22d4aaf97d.svg";
export { ForwardRef as ReactComponent };